const productTypes = {
  generalProduct: 'general_product',
  merchentProduct: 'merchent_product',
  userProduct: 'user_product'
};

export default productTypes;
